const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  title:state => state.settings.title,
  logo:state => state.settings.logo,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  permission: state =>state.permission.permissionList,
  roleId: state =>state.permission.roleId,
  hasPermission: state =>(id)=> {
    return  state.permission.permissionList.find((item)=> item==id)!=undefined
  },
  devId: state =>state.deviceSelect.devId,
  devList: state =>state.deviceSelect.devList,
  devType: state =>state.deviceSelect.devType,
}
export default getters
